export enum TypeColonneEnum {
  Numeric,
  Text,
  Boolean,
  Date
}